import IaasLogo from "../../assets/images/IaasLogo.png";
import VantageLogo from "../../assets/images/VantageLogo.png";
import LmsLogo from "../../assets/images/LmsLogo.png";
import SEO from "../../components/SEO";
import { Link } from "react-router-dom";
import useReveal from "../../hooks/useReveal";

const ProductPage = () => {
    const [headerRef, headerVisible] = useReveal();
    const [cardsRef, cardsVisible] = useReveal();
    const [ctaRef, ctaVisible] = useReveal();

    const services = [
        {
            title: "IaaS",
            description:
                "Cloud Computing infrastructure for scalable and secure virtual machine management. Deploy, scale, and manage your VMs, storage, and networking with ease — perfect for businesses needing flexibility and control.",
            url: "https://cloudvantage.com.ng/pricing/",
            icon: IaasLogo,
        },
        {
            title: "VantageCoops",
            description: "Cooperative Management Platform for seamless operations. Simplify cooperative society management with automated member registration, loan tracking, savings management, and detailed financial reporting—all in one unified system.",
            url: "https://vantagecoops.com/",
            icon: VantageLogo,
        },
        {
            title: "LMS",
            description:
                "A Learning Management Platform built for schools and organizations. Create courses, track progress, and monitor performance using an intuitive and customizable system that delivers engaging learning experiences.",
            url: "https://lms.cloudvantage.org.ng/",
            icon: LmsLogo,
        },
    ];

    return (
        <div>
            <SEO
                title="Our Products | CloudVantage"
                description="Explore CloudVantage's comprehensive suite of cloud products including IaaS, VantageCoops, and LMS solutions for scalable infrastructure and learning management."
                keywords="cloud products, IaaS, VantageCoops, LMS, cloud infrastructure, learning management system, cloudvantage products"
                author="CloudVantage"
                ogTitle="Our Products | CloudVantage"
                ogDescription="Explore CloudVantage's comprehensive suite of cloud products including IaaS, VantageCoops, and LMS solutions."
                ogImage="/assets/images/cloudvantage-products-og.jpg"
                ogUrl={typeof window !== 'undefined' ? window.location.href : ''}
            />

            <div className="flex flex-col min-h-screen bg-blue-50 dark:bg-[#141D26] text-black dark:text-white py-6">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
                    <div ref={headerRef} className={`text-center mb-12 lg:mb-16 space-y-3 ${headerVisible ? 'animate-reveal' : 'opacity-0'}`}>
                        <h1 className="text-4xl font-bold crimson-font dark:text-white">
                            Our Products
                        </h1>
                        <p className="max-w-2xl mx-auto text-lg text-slate-600 dark:text-gray-300">
                            We offer a suite of innovative digital solutions designed to empower organizations, enhance productivity, and simplify complex business processes through scalable and secure cloud technologies.
                        </p>
                    </div>

                    <div ref={cardsRef} className={`grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3 lg:gap-8 mb-12 lg:mb-16 ${cardsVisible ? 'animate-reveal' : 'opacity-0'}`}>
                        {services.map((service, index) => (
                            <a
                                key={index}
                                href={service.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="group bg-white/50 dark:bg-[#ffffff04] rounded-lg p-6 sm:p-8 lg:p-10 transition-all duration-300 transform hover:-translate-y-1"
                            >
                                <div className="text-center flex flex-col justify-between">
                                    <div>
                                    <div className="inline-flex items-center justify-center w-12 h-12 sm:w-14 sm:h-14 lg:w-16 lg:h-16 mb-2 sm:mb-3">
                                        <img
                                            src={service.icon}
                                            alt={`${service.title} Logo`}
                                            className="w-14 h-14 object-contain"
                                        />
                                    </div>

                                    <h3 className="text-xl font-semibold text-slate-800 dark:text-white mb-3 sm:mb-4 group-hover:text-blue-600 dark:group-hover:text-blue-400 transition-colors duration-300 crimson-font">
                                        {service.title}
                                    </h3>
                                    <p className="text-md text-slate-600 dark:text-gray-300 leading-relaxed mb-4">
                                        {service.description}
                                    </p>
                                    </div>
                                    <button className="bg-[#1DA1F2] text-white text-sm px-8 py-4 rounded-sm hover:bg-[#1a8fd1] transition-colors">
                                        Get Started
                                    </button>
                                </div>
                            </a>
                        ))}
                    </div>
                </div>

                <div ref={ctaRef} className={`text-center mb-12 lg:mb-16 space-y-4 px-4 ${ctaVisible ? 'animate-reveal' : 'opacity-0'}`}>
                    <h2 className="text-3xl font-bold text-black dark:text-white crimson-font">
                        Deploy and Scale Seamlessly with CloudVantage Cloud Platform
                    </h2>
                    <p className="text-black dark:text-gray-300 text-md">
                        Experience high-performance compute and storage — at exclusive introductory rates!
                    </p>
                    <Link to="/pricing">
                        <button className="bg-[#1DA1F2] text-white text-sm px-8 py-4 rounded-sm hover:bg-[#1a8fd1] transition-colors mt-6">
                            Spin up a VM
                        </button>
                    </Link>
                </div>
            </div>

        </div>
    );
};

export default ProductPage;